import React from 'react';
import { Button, ButtonProps } from '@mui/material';
import styled from 'styled-components';
import { Link, LinkProps } from 'react-router-dom';

interface HeaderButtonProps extends ButtonProps {
  to?: string;
  component?: React.ForwardRefExoticComponent<LinkProps & React.RefAttributes<HTMLAnchorElement>>;
}

const StyledWrapper = styled.div`
  & button {
    height: 100%;
    text-align: center;
    white-space: nowrap;
  }

  & a {
    height: 100%;
    text-align: center;
    white-space: nowrap;
  }

  @media (max-width: ${(props) => props.theme.breakpoints.md}px) {
    & button {
      padding: 0.5em 1em;
      font-size: 1em;
    }

    & a {
      padding: 0.5em 1em;
      font-size: 1em;
    }
  }

  @media (max-width: ${(props) => props.theme.breakpoints.sm}px) {
    & button {
      padding: 0.2em 0.5em;
      font-size: 0.8em;
    }

    & a {
      padding: 0.2em 0.5em;
      font-size: 0.8em;
    }
  }

  @media (max-width: ${(props) => props.theme.breakpoints.md / 2}px) {
    & button {
      padding: 0.5em 0.3em;
      font-size: 0.8em;
    }

    & a {
      padding: 0.5em 0.3em;
      font-size: 0.8em;
    }
  }

  @media (max-width: ${(props) => props.theme.breakpoints.sm / 2}px) {
    & button {
      padding: 0.1em 0.2em;
      font-size: 0.64em;
    }

    & a {
      padding: 0.1em 0.2em;
      font-size: 0.64em;
    }
  }
`;

export const HeaderButton = ({
  children,
  onClick,
  to,
  disabled = false,
  ...otherProps
}: HeaderButtonProps) => {
  const buttonProps: HeaderButtonProps = {
    variant: 'contained',
    color: 'secondary',
    disabled,
  };

  if (onClick) {
    buttonProps.onClick = onClick;
  }

  if (to && !disabled) {
    buttonProps.component = Link;
    buttonProps.to = to;
  }

  return (
    <StyledWrapper>
      <Button {...otherProps} {...buttonProps}>
        {children}
      </Button>
    </StyledWrapper>
  );
};

export default HeaderButton;
